import React, { useEffect } from "react";
import {
    Button,
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
    Typography,
} from "@material-tailwind/react";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import RHFInput from "components/form/rhf-input";
import RHFTextarea from "components/form/rhf-textarea";
export default function CreateSurveyDialog({
    show,
    setShow,
    initialValues,
    handleSubmit,
    validationSchema,
}) {
    const methods = useForm({
        mode: "onChange",
        resolver: validationSchema ? yupResolver(validationSchema) : undefined,
        defaultValues: initialValues,
    });
    const {
        reset,
        formState: { isValid, isDirty },
    } = methods;

    // Reset once per open transition so the form restarts from the
    // caller's initialValues. initialValues must stay out of the deps:
    // the caller rebuilds it every render (not parent state), so keying
    // on it would wipe in-progress input mid-open.
    useEffect(() => {
        if (show) {
            reset(initialValues);
        }
    }, [show, reset]);

    const handleClose = () => {
        setShow((prev) => !prev);
    };
    return (
        <Dialog
            open={show}
            handler={handleClose}
            className="dialog"
        >
            <DialogHeader className="dialog__header">
                <Typography variant="h2">Create A New Survey</Typography>
            </DialogHeader>

            <FormProvider {...methods}>
                <form onSubmit={methods.handleSubmit(handleSubmit)}>
                    <DialogBody className="dialog__body">
                        <div className="dialog__section">
                            <RHFInput
                                className="font-body"
                                name="name"
                                type="text"
                                label="Survey Title (respondents will see this text)"
                                required
                            />
                        </div>

                        <div className="dialog__section">
                            <RHFTextarea
                                name="description"
                                className="text-lg font-body text-primary-text"
                                label="Survey Description (for your reference only)"
                            />
                        </div>
                    </DialogBody>

                    <DialogFooter className="dialog__footer">
                        <Button
                            type="button"
                            className="btn btn--secondary"
                            onClick={handleClose}
                        >
                            Cancel
                        </Button>
                        <Button
                            type="submit"
                            className="btn btn--primary"
                            disabled={!(isValid && isDirty)}
                        >
                            Create
                        </Button>
                    </DialogFooter>
                </form>
            </FormProvider>
        </Dialog>
    );
}
